import { render, staticRenderFns } from "./adsorption-reference-species-detail.vue?vue&type=template&id=65ee363c&"
import script from "./adsorption-reference-species-detail.vue?vue&type=script&lang=js&"
export * from "./adsorption-reference-species-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports